import globalAxios from 'axios';
import { DUMMY_BASE_URL, setApiKeyToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common.js';
import { operationServerMap, BaseAPI, BASE_PATH } from '../base.js';

/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 *
 * Jellyfin API
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/**
 * ClientLogApi - axios parameter creator
 * @export
 */
const ClientLogApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Upload a document.
         * @param {File} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logFile: async (body, options = {}) => {
            const localVarPath = `/ClientLog/Document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'text/plain';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ClientLogApi - functional programming interface
 * @export
 */
const ClientLogApiFp = function (configuration) {
    const localVarAxiosParamCreator = ClientLogApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Upload a document.
         * @param {File} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logFile(body, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.logFile(body, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ClientLogApi.logFile']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ClientLogApi - factory interface
 * @export
 */
const ClientLogApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ClientLogApiFp(configuration);
    return {
        /**
         *
         * @summary Upload a document.
         * @param {ClientLogApiLogFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logFile(requestParameters = {}, options) {
            return localVarFp.logFile(requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ClientLogApi - object-oriented interface
 * @export
 * @class ClientLogApi
 * @extends {BaseAPI}
 */
class ClientLogApi extends BaseAPI {
    /**
     *
     * @summary Upload a document.
     * @param {ClientLogApiLogFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientLogApi
     */
    logFile(requestParameters = {}, options) {
        return ClientLogApiFp(this.configuration).logFile(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ClientLogApi, ClientLogApiAxiosParamCreator, ClientLogApiFactory, ClientLogApiFp };
